import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_ProviderSelection = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_ProviderSelection' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> Provider Selection Form </center> </p>
                <p className='w-750'>
                    I

                    <input type='text' id='txtProviderSelectionFormAcknowledge' name='txtProviderSelectionFormAcknowledge' className='add-only' />
                    have chosen to select Restore Outreach Center, LLC as my service provider for my behavioral health services.
                    <br />
                    I have been presented with other agencies of choice and have not been coerced into choosing Restore Outreach Center, LLC as my provider.
                    <br />
                    I have also been oriented in the procedure and nature of the services that are provided by Restore Outreach Center, LLC

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Consumer/Guardian</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Staff Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}